import _ from 'lodash'

const state = () => ({
  loading: false,
  type: 'product',
  products: [],
  selectedProduct: null,
  selectedBaseProduct: null,
  options: [],
  selected: [],
  limit: 500,
  search: ''
})

const actions = {
  async getProduct ({state}, id) {
    state.loading = true
    await axios.get(`api/user/payment-systems/products/${id}`)
      .then(({data}) => {
        state.loading = false
        return data.data
      })
  },
  async getProductList ({ state, rootState }) {
    try {
      state.loading = true

      if (state.type === 'product') {
        const {data} = await axios.get(
          `api/user/payment-systems/products?project_id=${rootState.projects.project.id}&per_page=${state.limit}&q=${state.search}`
        )
        state.products = data.data.data
      } else if (state.type === 'package') {
        const {data} = await axios.get(
          `api/admin/crm/subscriptions/plans?per_page=${state.limit}&q=${state.search}`
        )
        state.products = data.data[0]?.data.filter(item => item.is_active) || []
      } else if (state.type === 'plan') {
        const {data} = await axios.get(
          `api/admin/crm/plans?per_page=${state.limit}&q=${state.search}`
        )
        state.products = data.data[0].data.filter(item => item.is_active) || []
      }

      state.selectedProduct = state.products.length > 0 ? state.products[0] : null
    } catch (error) {
      console.error('Error fetching product list:', error)
    } finally {
      state.loading = false
    }
  },
  differenceOptions ({state}) {
    state.options = _.filter(state.products, item => !_.includes(state.selected, item))
  }
}

const mutations = {
  SET_TYPE (state, payload) {
    state.type = payload
  },
  SET_SELECTED_PRODUCT (state, payload) {
    state.selectedProduct = payload
  },
  SET_SELECTED_BASE_PRODUCT (state, payload) {
    state.selectedBaseProduct = payload
  },
  SET_SELECTED (state, payload) {
    state.selected = payload
  },
  PUSH_SELECTED (state, payload) {
    state.selected.push(payload)
  },
  SPLICE_SELECTED (state, payload) {
    state.selected.splice(payload, 1)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}